import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ArticleBlockComponent } from '@modules/knowledge/components/article-block/article-block.component';
import { ArticleComponent } from '@modules/knowledge/pages/article/article.component';
import { OnboardingWelcomeComponent } from '@modules/onboarding/components/onboarding-welcome/onboarding-welcome.component';
import { HasFeatureDirective } from '@modules/organisation-workspaces/directives/has-feature.directive';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { AvatarComponent } from './components/avatar/avatar.component';
import { DialogComponent } from './components/dialog/dialog.component';
import { MenuComponent } from './components/menu/menu.component';
import { MessageViewerComponent } from './components/message-viewer/message-viewer.component';
import { IconsComponent } from './layout/icons/icons.component';
import { MaterialModule } from './material.module';
import { LineBreakPipe } from './pipes/line-break-pipe';
import { FindMediaIconPipe } from './pipes/media-icon.pipe';
import { MediaTypePipe } from './pipes/media-type.pipe';
import { ImageToBase64Pipe } from './pipes/image-to-base64.pipe';

const declarations = [
  MenuComponent,
  MessageViewerComponent,
  AvatarComponent,
  IconsComponent,
  DialogComponent,
  OnboardingWelcomeComponent,
  ArticleComponent,
  ArticleBlockComponent,
  MediaTypePipe,
  FindMediaIconPipe,
  ImageToBase64Pipe,
  HasFeatureDirective,
  LineBreakPipe,
];

/**
 * What the application shell itself draws — the menu and the message viewer — and the few
 * building blocks they are made of. The only shared module the eager `AppModule` imports.
 *
 * `SharedModule` declares the feature screens used across modules (the certificate, qualification
 * and attendee dialogs, the learning plan course page, …): over a megabyte of code that is only of
 * use once a workspace is opened. Imported by `AppModule`, all of it was in the initial bundle and
 * kept pushing it over its 4 MB budget. Now it loads with the lazy modules that use it.
 *
 * `SharedModule` imports and exports this module, so every feature module still sees all of it.
 * Keep this one small: anything added here is downloaded before the first screen is drawn.
 */
@NgModule({
  declarations,
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    TranslatePipe, TranslateDirective,
    MaterialModule,
    OverlayModule,
  ],
  exports: declarations,
})
export class SharedBaseModule {}
